<template>
    <form @submit.prevent="handleSubmit" method="POST" :action="action" v-loading="state==='loading'">
        <template v-if="hasErrorAlert">
            <div class="alert alert-danger">
                {{ message }}
            </div>
        </template>
        <template v-else-if="hasSuccessAlert">
           <slot name="success" :message="message">
               <div class="alert alert-success">
                   {{ message }}
               </div>
           </slot>
        </template>
        <div v-show="!(state==='success' && replaceWithMessage)">
            <slot :state="state" />
        </div>
    </form>
</template>

<script>
import axios from 'axios';
import Field from "./Field";

export default {
        name: 'AcaForm',
        props: {
            action: {
                type: String,
                required: true
            },
            replaceWithMessage: Boolean,
            noAlert: Boolean,
            successMessage: String,
            successUrl: String,
        },
        provide() {
            return {
                form:this
            }
        },
        data() {
            return {
                state: null,
                message: null,
                fields: {},
                loading: {},
            }
        },
        computed: {
            hasErrorAlert() {
                return this.state === 'error' && !this.noAlert || this.state === 'failed';
            },
            hasSuccessAlert() {
                return this.state === 'success' && this.message;
            }
        },
        methods: {
            submit() {
                this.$emit('submit');
                this.state = "loading";
                this.message = null;
                this.clearFields();
                return axios.post(this.action, new FormData(this.$el))
                    .then(response => {
                        this.$emit('success', response);
                        this.state = 'success';
                        this.message = response.data.message || this.successMessage;
                        this.clearFields();
                        const successUrl = response.data.url ?? this.successUrl;
                        if(successUrl) {
                            this.navigate(successUrl);
                        }
                        return response;
                    })
                    .catch(error => {
                        this.$emit('error', error);
                        if(error?.response?.status === 422) {
                            const data = error.response.data;
                            this.state = 'error';
                            this.message = 'Il y a une ou plusieurs erreurs dans le formulaire';
                            this.setFieldsError(data.errors);
                            this.scrollToForm();
                        } else {
                            this.state = 'failed';
                            this.message = "Impossible d'envoyer le formulaire, veillez réessayer plus tard";
                        }
                        return Promise.reject(error);
                    });
            },
            handleSubmit(e) {
                this.submit();
            },
            scrollToForm() {
                const modal = this.$el.closest('.modal');
                if(modal) {
                    modal.scrollTop = 0;
                } else {
                    const rect = this.$el.getBoundingClientRect();
                    window.scrollBy(0, rect.y - 200);
                }
            },
            navigate(url) {
                if(url.match(/^#/)) {
                    history.replaceState(null, null, url);
                    location.reload();
                } else {
                    location.replace(url);
                }
            },
            async setFieldsError(errors) {
                await this.$nextTick();
                Object.values(this.fields)
                    .filter(field => !!field)
                    .forEach(field => {
                        const error = errors[field.name];
                        if(error) {
                            field.setError(error[0]);
                        }
                    });
            },
            clearFields() {
                Object.values(this.fields)
                    .filter(field => !!field)
                    .forEach(field => {
                        field.clear();
                    });
            },
            /** @see Upload */
            setLoading(fieldName, loading) {
                this.loading[fieldName] = loading;
                const isLoading = Object.values(this.loading).some(loading => !!loading);
                const submitButton = this.$el.querySelector('[type=submit]:not([form])');
                if(!this.submitLabel) {
                    this.submitLabel = submitButton.innerText;
                }
                if(isLoading) {
                    submitButton.setAttribute('disabled', '');
                    submitButton.innerText = 'Téléchargement...';
                } else {
                    submitButton.removeAttribute('disabled');
                    submitButton.innerText = this.submitLabel;
                }
            },
            /** @see Field */
            registerField(field) {
                if(field.name) {
                    this.fields = {
                        ...this.fields,
                        [field.name]: field,
                    }
                }
            },
            /** @see Field */
            unregisterField(field) {
                this.fields = {
                    ...this.fields,
                    [field.name]: null,
                }
            },
        },
        created() {
            if(this.successUrl && this.successUrl === location.hash) {
                history.replaceState(null, null, location.pathname + location.search);
            }
        },
    }
</script>

